import { DOCUMENT } from '@angular/common';
import { Inject, Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { Client } from 'src/app/types';

@Injectable({
  providedIn: 'root',
})
export class ClientStylesService {
  private renderer: Renderer2;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private rendererFactory: RendererFactory2
  ) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }
  set(client: Client, lang: string) {
    this.renderer.setAttribute(this.document.documentElement, 'lang', lang);

    this.renderer.setAttribute(
      this.document.documentElement,
      'class',
      client?.layout ?? 'generic'
    );

    const { colors } = client;

    // TODO: Rename all of these with the size hyphenated like -30 or -6
    const borderRadiusStyles = {
      '--app-border-radius-xl':
        client.cornerSetting === 'SQUARE' ? '0px' : '30px',
      '--app-border-radius-l':
        client.cornerSetting === 'SQUARE' ? '0px' : '24px',
      '--app-border-radius-16':
        client.cornerSetting === 'SQUARE' ? '0px' : '16px',
      '--app-border-radius-12':
        client.cornerSetting === 'SQUARE' ? '0px' : '12px',
      '--app-border-radius': client.cornerSetting === 'SQUARE' ? '0px' : '8px',
      '--app-border-radius-md':
        client.cornerSetting === 'SQUARE' ? '0px' : '10px',
      '--app-border-radius-sm':
        client.cornerSetting === 'SQUARE' ? '0px' : '6px',
      '--app-border-radius-xs':
        client.cornerSetting === 'SQUARE' ? '0px' : '4px',
    };

    const colorStyles = {
      '--app-secondary-bg-color': '#FFF',
      '--app-bg-color': colors.appBgColor,
      '--app-card-bg-color': colors.appCardBgColor,
      '--app-alternate-bg-color': colors.appAlternateBgColor,
      '--app-primary-color': colors.appPrimaryColor,
      '--app-secondary-color': colors.appSecondaryColor,
      '--app-on-primary-color': colors.appOnPrimaryColor,
      '--app-on-secondary-color': colors.appOnSecondaryColor,
      '--app-divider-color': colors.appDividerColor,
      '--app-text-color': colors.appTextColor,
      '--app-text-alternate-color': colors.appTextAlternateColor,
      '--app-input-hover-active-color': colors.appInputHoverActiveColor,
      '--app-ribbon-featured-bg-color': colors.appRibbonFeaturedBgColor,
      '--app-ribbon-featured-font-color': colors.appRibbonFeaturedFontColor,
      '--app-ribbon-new-bg-color': colors.appRibbonNewBgColor,
      '--app-ribbon-new-font-color': colors.appRibbonNewFontColor,
      '--app-ribbon-booked-bg-color': colors.appRibbonBookedBgColor,
      '--app-ribbon-booked-font-color': colors.appRibbonBookedFontColor,
      '--app-ribbon-rented-bg-color': colors.appRibbonRentedBgColor,
      '--app-ribbon-rented-font-color': colors.appRibbonRentedFontColor,
      '--app-ribbon-sale-bg-color': colors.appRibbonSaleBgColor,
      '--app-ribbon-sale-font-color': colors.appRibbonSaleFontColor,
      '--app-ribbon-sold-bg-color': colors.appRibbonSoldBgColor,
      '--app-ribbon-sold-font-color': colors.appRibbonSoldFontColor,
    };

    const styleString = Object.entries({
      ...borderRadiusStyles,
      ...colorStyles,
    })
      .map(([key, value]) => `${key}: ${value}`)
      .join('; ');

    this.renderer.setAttribute(
      this.document.documentElement,
      'style',
      styleString
    );
  }
}
